import { render, staticRenderFns } from "./Alerts.vue?vue&type=template&id=a0e1b5b6&"
import script from "./Alerts.vue?vue&type=script&lang=js&"
export * from "./Alerts.vue?vue&type=script&lang=js&"
import style0 from "./Alerts.vue?vue&type=style&index=0&id=a0e1b5b6&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a0e1b5b6')) {
      api.createRecord('a0e1b5b6', component.options)
    } else {
      api.reload('a0e1b5b6', component.options)
    }
    module.hot.accept("./Alerts.vue?vue&type=template&id=a0e1b5b6&", function () {
      api.rerender('a0e1b5b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/administration/notifications/Alerts.vue"
export default component.exports